import React from 'react';
import { RelativeLoaderTemplate } from 'themes/components';

function RelativeLoader() {
	return <RelativeLoaderTemplate />;
}

export default RelativeLoader;



// WEBPACK FOOTER //
// ./src/core/components/RelativeLoader.jsx